import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './style';
import Header from './header';
import Banner from './banner';
import Rsvp from './rsvp';
import UserContext from 'context/UserContext';
import PopoverRSVP from "./components/PopoverRSVP"

const message = {
    "published": "published",
    "invited": "invited",
    "invite_scheduled": "scheduled for invite"
}

const EventVenue = withStyles(styles)(({ classes, form_props, ...rest }) => {

    const { subOrgDetails } = React.useContext(UserContext);

    const showToastForEventVenue = () => {
        rest.showNotification(`Event venue cannot be edited as it has been already ${message[rest.status]}.`, "error")
    }
    const showToastForDate = () => {
        rest.showNotification(`Date & time cannot be edited as it has been already ${message[rest.status]}.`, "error")
    }
    const handleClick = (fields) => {
        form_props.setFieldValue("leadFields", fields)
    }
    return (
        <div>
            <div className={classes.superContainer}>
                <div>
                    <div className={classes.mainContainer}>
                        <Header  {...form_props} {...rest} onTryToEdit={showToastForDate} />
                        <div className={classes.subContainer}>
                            <div className={classes.leftContainer}>
                                <Banner {...form_props} {...rest} />
                            </div>
                            <div className={classes.rightContainer}>
                                <PopoverRSVP
                                    {...form_props}
                                    hylyFormFields={rest.hylyFormFields}
                                    onConfirmClick={handleClick} />
                                <Rsvp {...form_props} {...rest} onTryToEdit={showToastForEventVenue} />
                            </div>
                        </div>
                        <div className={classes.footer}>
                            <img src={subOrgDetails.propertyManagerLogoUrl} alt="logo" className={classes.footerImage} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
})

export default EventVenue;
